var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDatabaseCropped(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    zoomAndPan: "magnify",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "355.63 97.15 252.63 347.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "f63564a6d4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 355.625 271 L 608.25 271 L 608.25 380 L 355.625 380 Z M 355.625 271 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "da04c48994"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 355.625 343 L 608.25 343 L 608.25 444.976562 L 355.625 444.976562 Z M 355.625 343 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "997e963b72"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 355.625 199 L 608.25 199 L 608.25 308 L 355.625 308 Z M 355.625 199 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "468726b2ec"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 355.625 133 L 608.25 133 L 608.25 236 L 355.625 236 Z M 355.625 133 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "56e6e2f385"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 355.625 187 L 608.25 187 L 608.25 236 L 355.625 236 Z M 355.625 187 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7ddfd76260"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 355.625 259 L 608.25 259 L 608.25 308 L 355.625 308 Z M 355.625 259 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "234f25dadb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 355.625 331 L 608.25 331 L 608.25 380 L 355.625 380 Z M 355.625 331 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "90d5541141"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 355.625 397 L 608.25 397 L 608.25 444.976562 L 355.625 444.976562 Z M 355.625 397 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "617b0c06ec"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 355.625 97.148438 L 608.25 97.148438 L 608.25 170 L 355.625 170 Z M 355.625 97.148438 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1b8ef8b41f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 355.625 127 L 608.25 127 L 608.25 170 L 355.625 170 Z M 355.625 127 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f63564a6d4)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2488ff",
    d: "M 481.9375 379.011719 C 551.628906 379.011719 608.101562 362.902344 608.101562 343.027344 L 608.101562 271.0625 C 608.101562 290.9375 551.628906 307.046875 481.9375 307.046875 C 412.246094 307.046875 355.773438 290.9375 355.773438 271.0625 L 355.773438 343.027344 C 355.773438 362.902344 412.246094 379.011719 481.9375 379.011719 Z M 481.9375 379.011719 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#da04c48994)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#006df0",
    d: "M 608.101562 408.996094 L 608.101562 343.027344 C 608.101562 362.902344 551.628906 379.011719 481.9375 379.011719 C 412.246094 379.011719 355.773438 362.902344 355.773438 343.027344 L 355.773438 408.996094 C 355.773438 428.871094 412.246094 444.976562 481.9375 444.976562 C 551.628906 444.976562 608.101562 428.871094 608.101562 408.996094 Z M 608.101562 408.996094 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#997e963b72)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#57a4ff",
    d: "M 481.9375 307.046875 C 551.628906 307.046875 608.101562 290.9375 608.101562 271.0625 L 608.101562 199.097656 C 608.101562 218.972656 551.628906 235.082031 481.9375 235.082031 C 412.246094 235.082031 355.773438 218.972656 355.773438 199.097656 L 355.773438 271.0625 C 355.773438 290.9375 412.246094 307.046875 481.9375 307.046875 Z M 481.9375 307.046875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#468726b2ec)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9bc9ff",
    d: "M 481.9375 235.082031 C 551.628906 235.082031 608.101562 218.972656 608.101562 199.097656 L 608.101562 133.128906 C 608.101562 153.003906 551.628906 169.113281 481.9375 169.113281 C 412.246094 169.113281 355.773438 153.003906 355.773438 133.128906 L 355.773438 199.097656 C 355.773438 218.972656 412.246094 235.082031 481.9375 235.082031 Z M 481.9375 235.082031 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#56e6e2f385)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2488ff",
    d: "M 608.101562 187.105469 L 608.101562 199.097656 C 608.101562 218.949219 551.628906 235.082031 481.9375 235.082031 C 412.246094 235.082031 355.773438 218.949219 355.773438 199.097656 L 355.773438 187.105469 C 355.773438 206.953125 412.246094 223.085938 481.9375 223.085938 C 551.628906 223.085938 608.101562 206.953125 608.101562 187.105469 Z M 608.101562 187.105469 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7ddfd76260)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#006df0",
    d: "M 608.101562 259.070312 L 608.101562 271.0625 C 608.101562 290.914062 551.628906 307.046875 481.9375 307.046875 C 412.246094 307.046875 355.773438 290.914062 355.773438 271.0625 L 355.773438 259.070312 C 355.773438 278.917969 412.246094 295.050781 481.9375 295.050781 C 551.628906 295.050781 608.101562 278.917969 608.101562 259.070312 Z M 608.101562 259.070312 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#234f25dadb)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#005ece",
    d: "M 608.101562 331.035156 L 608.101562 343.027344 C 608.101562 362.878906 551.628906 379.011719 481.9375 379.011719 C 412.246094 379.011719 355.773438 362.878906 355.773438 343.027344 L 355.773438 331.035156 C 355.773438 350.882812 412.246094 367.015625 481.9375 367.015625 C 551.628906 367.015625 608.101562 350.882812 608.101562 331.035156 Z M 608.101562 331.035156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#90d5541141)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#005ece",
    d: "M 608.101562 397 L 608.101562 408.996094 C 608.101562 428.847656 551.628906 444.976562 481.9375 444.976562 C 412.246094 444.976562 355.773438 428.847656 355.773438 408.996094 L 355.773438 397 C 355.773438 416.851562 412.246094 432.984375 481.9375 432.984375 C 551.628906 432.984375 608.101562 416.851562 608.101562 397 Z M 608.101562 397 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#617b0c06ec)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#bddbff",
    d: "M 608.101562 133.128906 C 608.101562 113.257812 551.617188 97.148438 481.9375 97.148438 C 412.257812 97.148438 355.773438 113.257812 355.773438 133.128906 C 355.773438 153 412.257812 169.113281 481.9375 169.113281 C 551.617188 169.113281 608.101562 153 608.101562 133.128906 Z M 608.101562 133.128906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1b8ef8b41f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#57a4ff",
    d: "M 608.101562 133.128906 C 608.101562 152.980469 551.628906 169.113281 481.9375 169.113281 C 412.246094 169.113281 355.773438 152.980469 355.773438 133.128906 C 355.808594 131.011719 356.410156 128.941406 357.515625 127.132812 C 367.488281 144.105469 419.394531 157.117188 481.9375 157.117188 C 544.480469 157.117188 596.386719 144.105469 606.359375 127.132812 C 607.464844 128.941406 608.066406 131.011719 608.101562 133.128906 Z M 608.101562 133.128906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabaseCropped);
export default __webpack_public_path__ + "static/media/database-cropped.7c404f9ec019af68c693dc92e18d9918.svg";
export { ForwardRef as ReactComponent };